import {memo, ReactNode} from 'react'

import classNames from 'classnames/bind'

import styles from './SummaryText.module.scss'

const cx = classNames.bind(styles)

interface SummaryTextProps {
    articleClassName?: string
    text: ReactNode
}

function SummaryText({articleClassName, text}: SummaryTextProps) {
    return <p className={cx('article', articleClassName)}>{text}</p>
}

export default memo(SummaryText)
